export type PostSection = {
  heading: string;
  paragraphs: string[];
};

export type Post = {
  id: string;
  title: string;
  summary: string;
  categorySlug: string;
  categoryLabel: string;
  tags: string[];
  author: string;
  publishedAt: string;
  readMinutes: number;
  views: number;
  heat: number;
  hot: boolean;
  cover: string;
  coverAlt: string;
  sections: PostSection[];
  timeline: { time: string; text: string }[];
};

export type Category = {
  slug: string;
  label: string;
  desc: string;
  icon: string;
  accent: string;
};

export type Faq = {
  q: string;
  a: string;
};

export const categories: Category[] = [
  {
    slug: 'star',
    label: '明星八卦',
    desc: '片场、剧组、颁奖礼，圈内人最想低调处理的那点事，这里替你拼好时间线。',
    icon: 'ri-star-smile-line',
    accent: 'primary',
  },
  {
    slug: 'influencer',
    label: '网红翻车',
    desc: '从涨粉神话到连夜删号，直播间里翻过的车、塌过的人设，一桩桩摆出来看。',
    icon: 'ri-live-line',
    accent: 'accent',
  },
  {
    slug: 'submit',
    label: '素人投稿',
    desc: '网友实名投稿台。年会、租房、通勤路上，你身边的故事也能成为下一个热帖。',
    icon: 'ri-mail-send-line',
    accent: 'secondary',
  },
  {
    slug: 'deep',
    label: '深度追踪',
    desc: '一个瓜的前因后果：时间线、证据链、各方回应与后续进展，一次讲清楚。',
    icon: 'ri-file-search-line',
    accent: 'foreground',
  },
];

export const posts: Post[] = [
  {
    id: 'p1',
    title: '林见鹿深夜现身片场遭围观，剧组连夜发声明解释拍摄调整',
    summary:
      '一条片场路透把林见鹿送上热搜。剧组凌晨两点发声明，解释当天临时调整机位的原因，但网友并不买账：为什么偏偏是那场夜戏被改？',
    categorySlug: 'star',
    categoryLabel: '明星八卦',
    tags: ['片场路透', '剧组声明', '夜戏调整'],
    author: '爆料编辑部',
    publishedAt: '2026-09-12 01:40',
    readMinutes: 6,
    views: 184320,
    heat: 98,
    hot: true,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20set%20at%20night%20with%20empty%20director%20chair%2C%20studio%20lights%20and%20light%20rain%2C%20no%20people%2C%20deep%20red%20and%20amber%20lighting%2C%20editorial%20photography%20high%20detail%2C%20consistent%20dark%20warm%20textured%20background&width=1280&height=800&seq=bla-p1-cover&orientation=landscape',
    coverAlt: '深夜片场空置的导演椅与灯光设备',
    sections: [
      {
        heading: '先说结论：这不是一次普通的改档',
        paragraphs: [
          '事情从一张模糊的片场路透开始。路人镜头里，林见鹿裹着外套从保姆车上下来，身后跟着三名工作人员，拍摄区域被围挡遮了大半。图不算清楚，但足够点燃讨论。',
          '按照剧组的说法，当天只是"因天气原因调整机位"，属于常规操作。不过很快有自称群演的账号出来说，被改掉的那场戏是整部剧最重要的转折夜戏，原定连拍四天，结果第二天就散了。',
          '一个解释是"技术原因"，一个是"临时撤场"，两者之间还差着一大段没说清的东西，这正是大家熬夜等后续的原因。',
        ],
      },
      {
        heading: '时间线里被忽略的两个细节',
        paragraphs: [
          '第一个细节是通勤车的进出记录。有在场的人回忆，当晚十一点还有另一辆同规格的保姆车开进围挡区域，随后两辆车前后脚离开。',
          '第二个细节是化妆组的收工时间。通常夜戏会留到凌晨，但那天化妆师比演员先走，说明至少有一场戏被彻底取消了。',
          '把这两点拼在一起，能看到一个更合理的推测：真正被临时叫停的，可能不是机位，而是某个人的到场安排。',
        ],
      },
      {
        heading: '各方回应与目前的进展',
        paragraphs: [
          '剧组在凌晨发布声明，强调"拍摄计划整体不受影响"，但通篇没有回应群演提到的撤场说法，也没有解释双车进出。',
          '林见鹿工作室暂未单独回应，只转发了剧组声明。眼尖的网友注意到，转发文案在半小时内被编辑过一次，删掉了"一切正常"四个字。',
          '截至发稿，该剧官方账号评论区已开启精选。我们会继续跟进，有新进展第一时间更新。',
        ],
      },
    ],
    timeline: [
      { time: '9月11日 22:50', text: '路人首次拍到片场围挡与保姆车' },
      { time: '9月11日 23:40', text: '自称群演账号称夜戏被临时撤场' },
      { time: '9月12日 01:10', text: '剧组发布凌晨声明' },
      { time: '9月12日 01:40', text: '工作室转发并编辑文案，删除"一切正常"' },
    ],
  },
  {
    id: 'p2',
    title: '百万粉主播糖豆酱带货翻车，直播间当场被刷屏',
    summary:
      '一场原本要冲数据的专场直播，在第十四分钟开始失控。弹幕从"上车"变成"退货"，主播中途离场十一分钟，回来时状态明显不对。',
    categorySlug: 'influencer',
    categoryLabel: '网红翻车',
    tags: ['直播带货', '人设翻车', '退货潮'],
    author: '围观小组',
    publishedAt: '2026-09-11 20:15',
    readMinutes: 5,
    views: 236780,
    heat: 96,
    hot: true,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20live%20streaming%20studio%20with%20ring%20light%2C%20camera%20and%20microphone%20on%20desk%2C%20no%20people%2C%20warm%20amber%20and%20red%20gradient%20lighting%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20dark%20textured%20background&width=1280&height=800&seq=bla-p2-cover&orientation=landscape',
    coverAlt: '空置的直播间环形灯与摄像设备',
    sections: [
      {
        heading: '第十四分钟，弹幕变了味道',
        paragraphs: [
          '直播间的气氛原本很标准：福袋、上链接、"家人们三二一"。变化发生在第十四分钟，一条"和上次买的不是一个东西"的弹幕出现后，类似的质疑开始滚动。',
          '有老粉翻出三个月前的开箱视频对比，指出包装、批次、赠品数量都对不上。也有不少人只是跟风刷屏，把"退货"当成新的口号。',
          '数据最能说明问题：这场直播的在线人数在中途达到峰值，随后断崖式下跌，留下的人里超过一半在发负面内容。',
        ],
      },
      {
        heading: '离场的十一分钟发生了什么',
        paragraphs: [
          '大约在第四十分钟，主播以"去换个设备"为由离场，镜头切到助播。十一分钟后回来，语速明显变慢，开始反复强调"有问题走正常流程"。',
          '有熟悉直播节奏的人指出，这种中途换人通常是团队在后台紧急商量话术。至于商量的结果，就是把主动权交还给消费者。',
          '当晚直播间没有关闭，但链接下架了大部分主推款。',
        ],
      },
      {
        heading: '后续：商家与主播各说各话',
        paragraphs: [
          '品牌方次日回应，称"批次差异属于正常生产波动"，愿意为有疑问的订单提供退换。',
          '主播团队则把问题归到"供应链协同"，并表示会优化选品流程。两边都很有礼貌，但没有人正面回答最核心的问题：差异到底有多大。',
          '我们整理了几位消费者的实拍对比放到文末图集，你可以自己判断。',
        ],
      },
    ],
    timeline: [
      { time: '20:00', text: '专场直播开播，主推三款商品' },
      { time: '20:14', text: '首批"货不对版"弹幕出现' },
      { time: '20:40', text: '主播离场十一分钟' },
      { time: '次日 11:00', text: '品牌方回应称批次差异属正常波动' },
    ],
  },
  {
    id: 'p3',
    title: '投稿：公司年会惊现"抢麦门"，当事人还原全过程',
    summary:
      '一位读者投来长文，讲述他们公司年会上，两位部门负责人为了谁上台发言当场僵住的全过程。尴尬程度，隔着屏幕都能抠出三室一厅。',
    categorySlug: 'submit',
    categoryLabel: '素人投稿',
    tags: ['职场日常', '年会', '素人投稿'],
    author: '读者投稿 · 阿航',
    publishedAt: '2026-09-11 14:30',
    readMinutes: 7,
    views: 96410,
    heat: 88,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20banquet%20hall%20with%20round%20tables%2C%20stage%20and%20single%20microphone%20stand%2C%20no%20people%2C%20warm%20gold%20string%20lights%20and%20soft%20red%20tones%2C%20cinematic%20editorial%20photography%2C%20consistent%20warm%20textured%20background%20high%20detail&width=1280&height=800&seq=bla-p3-cover&orientation=landscape',
    coverAlt: '年会宴会厅中空置的话筒架与舞台',
    sections: [
      {
        heading: '一个话筒，两个都不肯松手的人',
        paragraphs: [
          '投稿人阿航是一家两百人规模公司的普通员工。他形容那晚的场面："像看了一场没有剧本的双人舞，谁先退谁就输。"',
          '按流程，年会最后一个环节是各部门负责人上台说两句。灯光都打好了，主持人念完名字，A 部门和 B 部门的负责人同时起身，往同一个话筒走。',
          '然后就是长达半分钟的静止。台下先是笑，接着是尴尬的沉默，最后变成了整齐的"都上、都上"。',
        ],
      },
      {
        heading: '为什么会僵在台上',
        paragraphs: [
          '阿航给出的背景是：两个部门今年在预算分配上一直有分歧，年底复盘会刚吵过一轮，年会前的座次调整更是把火气压到了顶。',
          '在他看来，抢麦不是偶然，是长期矛盾在公开场合的一次"意外泄漏"。真正让人不适的，是所有人都知道原因，却要装作只是"热情"。',
          '最后是老板亲自上台，把两个人一左一右拉到身边，才结束了这场静默。',
        ],
      },
      {
        heading: '给同样要办年会的公司三点提醒',
        paragraphs: [
          '第一，流程表要写清"谁第几个上、站在哪个位置"，模糊地带最容易出事。',
          '第二，涉及跨部门同台的环节，提前对一次走位，成本极低，收益极高。',
          '第三，也是最重要的——别把没解决的分歧，塞进一个必须热闹的场合里解决。',
        ],
      },
    ],
    timeline: [
      { time: '环节前 30 分钟', text: '主持人临时调整发言顺序' },
      { time: '21:05', text: '两位负责人同时走向话筒' },
      { time: '21:06', text: '全场陷入约 30 秒的沉默' },
      { time: '21:07', text: '老板上台居中，环节继续' },
    ],
  },
  {
    id: 'p4',
    title: '从绯闻到解约：某顶流艺人口碑反转的 72 小时时间线',
    summary:
      '三天时间，舆论从一边倒到彻底反转。我们按小时拆解了这 72 小时里，每一次声明、每一次沉默，以及真正让风向改变的那个节点。',
    categorySlug: 'deep',
    categoryLabel: '深度追踪',
    tags: ['时间线', '声明解读', '舆论反转'],
    author: '深度组',
    publishedAt: '2026-09-10 19:00',
    readMinutes: 9,
    views: 312550,
    heat: 99,
    hot: true,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20folded%20newspapers%2C%20hourglass%20and%20old%20press%20camera%20on%20dark%20wood%20desk%2C%20no%20people%2C%20moody%20deep%20red%20and%20amber%20light%2C%20cinematic%20high%20detail%2C%20consistent%20dark%20textured%20background&width=1280&height=800&seq=bla-p4-cover&orientation=landscape',
    coverAlt: '深色木桌上折叠的报纸、沙漏与老式相机',
    sections: [
      {
        heading: '第 0 小时：一份没有署名的聊天截图',
        paragraphs: [
          '一切始于一份没有署名的聊天截图。因为信息不完整，最初只有小范围讨论，热度并不高。',
          '真正的转折出现在第 9 小时，某营销号搬运后加上了一句带节奏的解读，话题迅速冲上热搜。此时，当事人一方选择了沉默。',
          '在娱乐事件的传播规律里，前 12 小时的沉默通常会被解读为"默认"，这为后面的反转埋下了伏笔。',
        ],
      },
      {
        heading: '第 24 到 48 小时：两份声明，两种姿态',
        paragraphs: [
          '第 24 小时，工作室发出第一份声明，措辞克制，核心意思是"与事实不符，保留追责权利"，但没有提供任何时间或证据。',
          '第 40 小时，合作品牌陆续删除相关物料，被网友解读为"切割"。舆论在此时几乎一边倒。',
          '第 48 小时，第二份声明出现，这次附上了完整的时间线截图和原始文件属性信息，也第一次把矛头指向了截图来源。风向从这里开始松动。',
        ],
      },
      {
        heading: '第 72 小时：风向为什么真的变了',
        paragraphs: [
          '真正改变舆论的，不是声明的措辞，而是第三方账号独立复核了那份截图的时间戳，得出了与第二份声明一致的结论。',
          '当"可验证"取代"我觉得"，情绪化的讨论就会退潮。接下来两天，原本带节奏的账号开始删帖，话题热度随之回落。',
          '这 72 小时给出的启示其实很朴素：面对爆料，先问证据，再谈立场。这也是我们做深度追踪时一直坚持的顺序。',
        ],
      },
    ],
    timeline: [
      { time: '第 0 小时', text: '无署名聊天截图小范围流传' },
      { time: '第 9 小时', text: '营销号搬运，话题冲上热搜' },
      { time: '第 24 小时', text: '第一份声明发布，未附证据' },
      { time: '第 40 小时', text: '合作品牌下架相关物料' },
      { time: '第 48 小时', text: '第二份声明附时间线截图' },
      { time: '第 72 小时', text: '第三方独立复核，风向反转' },
    ],
  },
  {
    id: 'p5',
    title: '顾南辞新剧发布会临时改流程，主办方称"技术原因"',
    summary:
      '原定的群访环节在开场前十分钟被撤掉，改成了单向媒体拍摄。主办方一句"技术原因"，让到场的记者集体在群里发起了问号。',
    categorySlug: 'star',
    categoryLabel: '明星八卦',
    tags: ['发布会', '媒体群访', '流程变更'],
    author: '爆料编辑部',
    publishedAt: '2026-09-10 12:20',
    readMinutes: 4,
    views: 74560,
    heat: 79,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20press%20conference%20stage%20with%20microphones%20on%20podium%20and%20red%20backdrop%2C%20no%20people%2C%20warm%20spotlight%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20warm%20textured%20background&width=1280&height=800&seq=bla-p5-cover&orientation=landscape',
    coverAlt: '发布会舞台上并排摆放的采访话筒',
    sections: [
      {
        heading: '开场前十分钟的一封通知',
        paragraphs: [
          '到场媒体在开场前十分钟收到通知：原定的圆桌群访取消，改为统一拍摄，不设提问环节。',
          '主办方给的说法是"现场技术条件受限"。但记者们很快发现，背景板、话筒、录音设备都准备齐全，摄影区甚至比原计划更大。',
          '一位同行在群里吐槽："技术原因现在成了万能理由。"',
        ],
      },
      {
        heading: '为什么群访环节会被撤',
        paragraphs: [
          '业内常见的两种情况：一是主演团队担心被追问近期争议，二是宣发与艺人方对口径没谈拢。',
          '这次更接近后者。有参与筹备的人透露，发布会前一天双方还在就"哪些问题可以问"来回修改清单。',
          '当清单改到第三版仍然无法达成一致时，最省事的方案就只剩取消提问。',
        ],
      },
    ],
    timeline: [
      { time: '开场前 1 天', text: '双方就提问清单反复修改' },
      { time: '开场前 10 分钟', text: '通知取消群访，改为单向拍摄' },
      { time: '当日 15:00', text: '主办方统一回应"技术原因"' },
    ],
  },
  {
    id: 'p6',
    title: '"手工耿2.0"人设崩塌？合作方晒出聊天记录回应',
    summary:
      '以"手搓万物"走红的博主被指作品有代工，合作方放出聊天记录，博主则回应"部分环节确有外协"。这场关于"原创"的争论，比想象中更复杂。',
    categorySlug: 'influencer',
    categoryLabel: '网红翻车',
    tags: ['原创争议', '合作纠纷', '人设'],
    author: '围观小组',
    publishedAt: '2026-09-09 22:05',
    readMinutes: 6,
    views: 152300,
    heat: 90,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20workshop%20bench%20with%20hand%20tools%2C%20metal%20parts%20and%20wood%20shavings%2C%20no%20people%2C%20warm%20amber%20industrial%20lighting%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20dark%20textured%20background&width=1280&height=800&seq=bla-p6-cover&orientation=landscape',
    coverAlt: '手工工作台上散落的工具与金属零件',
    sections: [
      {
        heading: '"一个人做完整个作品"的滤镜碎了',
        paragraphs: [
          '该博主以"从零手搓、全程自己来"为招牌，视频里常出现通宵打磨、反复失败的片段，评论区把它称作"手艺人精神"。',
          '合作方的爆料核心只有一句话：视频里的大部分零部件，是由第三方工厂打样完成的，博主负责的是最后组装与拍摄。',
          '消息一出，关于"原创"和"人设"的界限讨论迅速扩散。',
        ],
      },
      {
        heading: '双方各执一词，焦点其实只有一个',
        paragraphs: [
          '博主回应称，确实有"部分环节外协"，但强调创意、结构设计和最终成品都出自自己团队，认为这是行业常态。',
          '合作方则不认可这个说法，认为视频把"外协"包装成了"全程手作"，属于误导。',
          '争论看似围绕"是否代工"，本质其实是"呈现方式有没有夸大人设"。这个区别，决定了性质完全不同。',
        ],
      },
      {
        heading: '我们的看法',
        paragraphs: [
          '内容创作里，借助外部资源并不丢人，问题在于有没有把它说清楚。观众愿意为"手作"买单，是因为相信那份投入，而不是相信某一颗螺丝是谁拧的。',
          '把边界讲明白，比争论谁对谁错更有价值。',
        ],
      },
    ],
    timeline: [
      { time: '9月9日 18:00', text: '合作方放出聊天记录' },
      { time: '9月9日 20:30', text: '博主发布回应视频' },
      { time: '9月9日 22:05', text: '话题冲上热搜，双方暂未再更新' },
    ],
  },
  {
    id: 'p7',
    title: '投稿：租房中介的"隐藏条款"，我踩过的三个坑',
    summary:
      '一位刚毕业的读者分享了自己的租房经历：三份看起来正常的合同，藏着三个让他多花了近两个月房租的条款。',
    categorySlug: 'submit',
    categoryLabel: '素人投稿',
    tags: ['租房', '合同陷阱', '素人投稿'],
    author: '读者投稿 · 小周',
    publishedAt: '2026-09-09 10:40',
    readMinutes: 7,
    views: 68820,
    heat: 76,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20modern%20rental%20apartment%20with%20sunlight%20through%20window%2C%20key%20and%20paper%20contract%20on%20table%2C%20no%20people%2C%20warm%20soft%20tones%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20warm%20textured%20background&width=1280&height=800&seq=bla-p7-cover&orientation=landscape',
    coverAlt: '洒进阳光的空置出租屋与桌上的钥匙合同',
    sections: [
      {
        heading: '坑一：写在小字里的"服务费"',
        paragraphs: [
          '小周签的第一份合同，月租看起来比同小区低两百，但附加条款里有一行小字：每月另收"服务费"，金额随行就市。',
          '一年下来，这笔费用几乎抹平了租金优势，还多出几百块。他后来才知道，这类收费必须签约前明确告知才合规。',
        ],
      },
      {
        heading: '坑二：押金退还的"模糊时间"',
        paragraphs: [
          '第二份合同写的是"退租后适时退还押金"，没有写具体天数。结果退租当天，中介说"要走流程"。',
          '这个流程走了整整一个月。小周的经验是：一定要把"X 个工作日内退还"写进合同，别接受任何模糊表述。',
        ],
      },
      {
        heading: '坑三：提前退租的高额违约金',
        paragraphs: [
          '第三份合同的违约金条款写着"剩余租期的全部租金"。因为工作调动，他不得不提前退租，最后赔付了一大笔。',
          '他总结说，签合同前一定要把三条看仔细：费用的构成、押金退的时间、违约的代价。这三条写清楚，能省下很多麻烦。',
        ],
      },
    ],
    timeline: [
      { time: '第 1 次', text: '低租金 + 隐藏服务费，一年多花约 2400 元' },
      { time: '第 2 次', text: '押金退还无期限，拖延一个月到账' },
      { time: '第 3 次', text: '提前退租违约金过高，赔付近两个月房租' },
    ],
  },
  {
    id: 'p8',
    title: '综艺剪辑争议全梳理：镜头分配背后到底发生了什么',
    summary:
      '一档热播综艺的镜头分配被指不公，争议从第一期末尾持续到第三期。我们把播出画面、花絮和现场记录对照了一遍。',
    categorySlug: 'deep',
    categoryLabel: '深度追踪',
    tags: ['综艺剪辑', '镜头分配', '对比分析'],
    author: '深度组',
    publishedAt: '2026-09-08 18:30',
    readMinutes: 8,
    views: 121400,
    heat: 85,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20television%20editing%20suite%20with%20multiple%20monitors%20and%20timeline%20software%2C%20no%20people%2C%20warm%20amber%20screen%20glow%20in%20dark%20room%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20dark%20textured%20background&width=1280&height=800&seq=bla-p8-cover&orientation=landscape',
    coverAlt: '暗色剪辑室中多块监控屏幕与时间线',
    sections: [
      {
        heading: '争议的起点：一个被"剪没"的镜头',
        paragraphs: [
          '第三期播出后，有观众发现某位嘉宾在花絮里的一段完整互动，正片里几乎全被删掉，只剩下一个背影。',
          '这条发现被整理成对比视频后迅速传播，讨论从"剪辑偏好"升级为"是否有意为之"。',
        ],
      },
      {
        heading: '把三份素材叠在一起看',
        paragraphs: [
          '我们对照了正片、会员花絮和现场观众的文字记录，发现一个关键差异：正片保留的是冲突性较强的片段，花絮保留的是协作片段。',
          '这意味着剪辑的取舍标准更偏向"戏剧张力"，而不是"谁的镜头被针对"。简单说，被剪掉的是平淡的部分，只是恰好都发生在同一个人身上。',
          '当然，这是从成片倒推的解释，节目组没有公布原始素材，我们也无法 100% 确认动机。',
        ],
      },
      {
        heading: '节目组回应与后续',
        paragraphs: [
          '节目组表示剪辑以"整体节奏"为先，不存在刻意针对。第四期播出后，该嘉宾的镜头明显增加，争议逐渐平息。',
          '这轮讨论最大的收获，或许是让更多观众意识到：我们看到的永远是剪辑后的版本，判断之前，先看看有没有别的素材。',
        ],
      },
    ],
    timeline: [
      { time: '第一期', text: '镜头分配首次引发弹幕讨论' },
      { time: '第三期', text: '花絮与正片差异被做成对比视频' },
      { time: '回应当日', text: '节目组称以整体节奏为先' },
      { time: '第四期', text: '相关嘉宾镜头明显增加' },
    ],
  },
  {
    id: 'p9',
    title: '颁奖礼座位图流出，网友为"谁坐第一排"吵了三天',
    summary:
      '一张座位示意图在活动前一天流出，C 位、第一排、边角的排序被逐帧分析。主办方的回应只有四个字："随机安排"。',
    categorySlug: 'star',
    categoryLabel: '明星八卦',
    tags: ['颁奖礼', '座位图', 'C位之争'],
    author: '爆料编辑部',
    publishedAt: '2026-09-07 21:00',
    readMinutes: 5,
    views: 143900,
    heat: 87,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20award%20ceremony%20auditorium%20with%20rows%20of%20red%20velvet%20chairs%20and%20stage%20lights%2C%20no%20people%2C%20warm%20gold%20and%20crimson%20tones%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20warm%20textured%20background&width=1280&height=800&seq=bla-p9-cover&orientation=landscape',
    coverAlt: '颁奖典礼礼堂中成排的红色绒面座椅',
    sections: [
      {
        heading: '一张图引发的"排位学"',
        paragraphs: [
          '座位图流出的当晚，相关讨论帖迅速堆到上千层。网友把第一排、中心区、入场动线全部标注出来，逐位对应到场嘉宾。',
          '在娱乐行业，座位确实常被视作某种"地位暗语"，这也是它每次都能引发讨论的原因。',
        ],
      },
      {
        heading: '主办方的四个字回应',
        paragraphs: [
          '面对询问，主办方仅回应"随机安排"，未提供更多细节。这个说法显然没能说服任何人。',
          '有执行层面的人解释，座位通常需要综合艺人档期、获奖可能、镜头需求和赞助商要求，远没有图上看起来那么"排资论辈"。',
        ],
      },
    ],
    timeline: [
      { time: '活动前 1 天', text: '座位示意图流出' },
      { time: '活动前 12 小时', text: '讨论帖超过千层' },
      { time: '活动当日', text: '主办方回应"随机安排"' },
    ],
  },
  {
    id: 'p10',
    title: '探店博主被商家"反向打假"，双方各自放出聊天记录',
    summary:
      '博主称店家份量缩水，店家则晒出监控与后厨记录，称博主"为流量刻意摆拍"。这可能是今年最有意思的一场攻防。',
    categorySlug: 'influencer',
    categoryLabel: '网红翻车',
    tags: ['探店', '反向打假', '各执一词'],
    author: '围观小组',
    publishedAt: '2026-09-06 16:45',
    readMinutes: 6,
    views: 108700,
    heat: 83,
    hot: false,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20empty%20cozy%20restaurant%20table%20with%20dishes%20and%20camera%20tripod%2C%20no%20people%2C%20warm%20amber%20evening%20lighting%2C%20cinematic%20editorial%20photography%20high%20detail%2C%20consistent%20warm%20textured%20background&width=1280&height=800&seq=bla-p10-cover&orientation=landscape',
    coverAlt: '暖光餐厅中摆着菜品与拍摄三脚架的餐桌',
    sections: [
      {
        heading: '博主先说：份量只有宣传的一半',
        paragraphs: [
          '博主发布的视频里，对比了菜单图片和实拍，指出主菜份量明显缩水，配文用了"照骗"两个字。视频播放量很快破百万。',
          '对一家小店来说，这种内容的杀伤力是直接的，当天就有网友在点评平台刷了差评。',
        ],
      },
      {
        heading: '店家反击：监控显示拍摄前后动过手',
        paragraphs: [
          '店家没有选择沉默，而是调出监控，指出博主在拍摄前要求"把配菜先挪走"，还在拍完后追加了一份。',
          '同时晒出的后厨出餐记录显示，当天主菜重量与标准一致。店家的结论是：这不是份量问题，是摆拍问题。',
        ],
      },
      {
        heading: '现在轮到我们看证据',
        paragraphs: [
          '两边都有材料，也都各说各话。目前能确认的是：博主确实调整过摆盘，店家也确实在宣传图里做过美化。',
          '这类争议最怕的就是只看立场不看过程。我们建议你把两份材料都看完再下判断。',
        ],
      },
    ],
    timeline: [
      { time: '9月5日', text: '博主发布探店视频，指份量缩水' },
      { time: '9月5日晚', text: '点评平台出现大量差评' },
      { time: '9月6日', text: '店家放出监控与出餐记录反击' },
      { time: '9月6日 16:45', text: '双方各自发布补充说明' },
    ],
  },
];

export const faqs: Faq[] = [
  {
    q: '18爆料网多久更新一次？',
    a: '我们保持每日更新，热门事件通常在数小时内整理成时间线上线。首页顶部的"今日更新"快讯条会实时滚动当天新增的爆料条目。',
  },
  {
    q: '网站上的爆料内容从哪里来？',
    a: '主要来自三个渠道：公开报道的二次梳理、网友主动投稿，以及编辑部的独立核查。所有内容都会标注来源类型，涉及未经证实的说法会明确写成"传闻"。',
  },
  {
    q: '我可以在 18爆料网投稿吗？',
    a: '可以。你可以在"素人投稿"栏目查看投稿要求，或直接通过订阅表单留下联系方式。编辑会在一到两个工作日内回复，涉及个人隐私的内容会做脱敏处理。',
  },
  {
    q: '为什么有些爆料只有时间线，没有结论？',
    a: '因为我们不替读者下结论。当一个事件还在发展中，我们会把可核实的部分整理成时间线，把不确定的部分标注清楚，等有新进展再更新，而不是抢先给一个看起来痛快的答案。',
  },
  {
    q: '如何辨别一条爆料是否可信？',
    a: '看三点：有没有可验证的原始材料、信息是否来自多方、时间线是否自洽。我们在每篇深度追踪里都会尽量附上这三类信息，也欢迎读者独立复核。',
  },
  {
    q: '内容涉及我本人，可以要求处理吗？',
    a: '可以。如果你认为某篇内容涉及你的个人权益，请通过页面底部的联系邮箱与我们沟通，我们会核实后及时处理。',
  },
];

export const stats = [
  { label: '每日新增爆料', value: '38', unit: '条' },
  { label: '累计收录事件', value: '1,260', unit: '起' },
  { label: '读者线索投稿', value: '5,400', unit: '份' },
  { label: '平均跟进时长', value: '72', unit: '小时' },
];